// Copyright 2016 Sorama B.V.

import { IParameterizedValueConverter } from "aurelia-binding-ext";
import { Unit, UnitValue } from "units/Unit";
import { UnitParser } from "units/UnitParser";

export class UnitValueToHumanReadableUnitValueValueConverter implements IParameterizedValueConverter<
    UnitValue,
    number,
    Unit | string
> {
    public toView(value: number, from: Unit | string): UnitValue {
        // Make chaining of this converter to a NullToX ValueConverter possible
        if (value === null || value === undefined) {
            return null;
        }

        const fromUnit = typeof from === "string" ? UnitParser.Parse(from) : <Unit>from;

        return fromUnit.toHumanReadableUnit(value);
    }

    public fromView(value: UnitValue, from: Unit | string): number {
        // Make chaining of this converter to a NullToX ValueConverter possible
        if (value === null || value === undefined) {
            return null;
        }

        const fromUnit = typeof from === "string" ? UnitParser.Parse(from) : <Unit>from;

        return fromUnit.fromUnit(value.unit, value.value);
    }
}
